exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.courseinfo-wrapper[data-v-2933bc94] {\n  background: #ffffff;\n}\n.courseinfo-wrapper iframe[data-v-2933bc94] {\n  width: 100%;\n}", "", {"version":3,"sources":["/var/corecdci/src/components/index/<input css 13>"],"names":[],"mappings":";AAAA;EACE,oBAAoB;CACrB;AAED;EACE,YAAY;CACb","file":"courseinfo.vue","sourcesContent":[".courseinfo-wrapper {\n  background: #ffffff;\n}\n\n.courseinfo-wrapper iframe {\n  width: 100%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2933bc94","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index/courseinfo.vue
// module id = 21jJ
// module chunks = 6